import { Pipe, PipeTransform } from '@angular/core';

import { FlexTimeActivity } from 'libs/domain';

@Pipe({
  name: 'additionalTeachers',
})
export class AdditionalTeachersPipe implements PipeTransform {
  constructor() {}

  transform(stuff: FlexTimeActivity): string | null {
    const mainTeacher = stuff.createdByPerson.hash;
    const additionalTeachers = stuff.teacherList?.members?.filter(member => member.hash !== mainTeacher);

    if (!additionalTeachers?.length) return null;

    return additionalTeachers.map(member => `${member.firstName} ${member.lastName}`).join(', ');
  }
}
